import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface CustomerDetailState {
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: CustomerDetailState = {
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

export const customerDetailSlice = createSlice({
  name: 'customerDetail',
  initialState,
  reducers: {
    setCustomerDetail: (state, action) => {
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewCustomerDetail: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCustomerDetail, addNewCustomerDetail, reset } = customerDetailSlice.actions;
export const getCustomerDetails = (state: RootState) => state.customerDetail.data;
export const getCustomerDetailTotalRecords = (state: RootState) => state.customerDetail.totalRecords;

export default customerDetailSlice.reducer;
